import { Component, Input } from '@angular/core';
import * as moment from 'moment';
import { CompanyLogoConfiguration } from 'src/app/models/auxiliary/company-logo-configuration';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-events-list-report',
  templateUrl: './events-list-report.component.html',
  styleUrls: ['./events-list-report.component.scss']
})
export class EventsListReportComponent {

  @Input() reportId: string;
  @Input() printEventList: [];

  date= new Date();

  moment = moment;
  companyLogo: CompanyLogoConfiguration = null;


  constructor(public commonDataService: CommonDataService) {
    this.companyLogo = new CompanyLogoConfiguration();
  }
  ngOnInit() {
    this.commonDataService.getCompanyLogo().subscribe((labConfiguration: CompanyLogoConfiguration) => {
      this.companyLogo = labConfiguration;
    });
  }

}
